import Drawer from "../../../../drawer/Drawer";
import ManagePage from "../ManagePage";

const ManagePageDrawer = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Drawer
      open={open}
      onClose={(val) => {
        close(val);
      }}
      actualSize={"xl"}
      size={"xl2"}
      title={data?._id ? "Update Page" : "Add Page"}
      subtitle="View, update and modify user details and information bellow"
      drawerBodyclassName="p-0 max-h-[calc(100%-90px)]"
    >
      <div className="h-full overflow-y-auto">
        <ManagePage getResponse={getResponse} close={close} data={data} />
      </div>
    </Drawer>
  );
};

export default ManagePageDrawer;
